import { usersAcceptInvitation, UsersAcceptInvitationProps } from "@/services/users-accept-invitation";
import { useToast } from "@/hooks/use-toast";

export const useAPIUsersAcceptInvitation = () => {
  const { showToastByCode } = useToast();
  
  const handleAPIUsersAcceptInvitation = async (props: UsersAcceptInvitationProps) => {
    try {
      const res = await usersAcceptInvitation(props);
      return res;
    } catch (error) {
      showToastByCode(error);
      throw error;
    }
  };

  return {
    handleAPIUsersAcceptInvitation,
  };
};

